<template>
    <rkm-layout-body title="Lista de CIDs">

        <rkm-layout-content>
            <List />
        </rkm-layout-content>
    </rkm-layout-body>
</template>

<script>
import List from '@/components/parametrizacao/tabela-cid/List'

export default {
    components: { List },
}
</script>